import AuthLayout from "layouts/AuthLayout";
import type { RegisterFormModel } from "pages/accounts-onboarding/models";
import { RegisterPage } from "pages/accounts-onboarding/register";
import React from "react";

const RegisterRoute = () => {
	const initialValues: RegisterFormModel = {
		// Unticked by default, always: a pre-ticked consent box is not consent.
		acceptedTerms: false,
		email: "",
		fullName: "",
		password: "",
		turnstileToken: "",
		website: ""
	};

	return (
		<AuthLayout>
			<RegisterPage initialValues={initialValues} />
		</AuthLayout>
	);
};

export default RegisterRoute;
